import React, { useEffect, useState } from "react";
import { getCurrentGoldPriceAction } from "../../../../store/actions/dashboard/DashboardActions";
import currenyFormat from "../../common/currentFormat";

const Amount = () => {
  const [goldPrice, setGoldPrice] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchGoldPrice = async () => {
      try {
        setLoading(true);
        const result = await getCurrentGoldPriceAction();
        setGoldPrice(result.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch gold price:", error);
      }
    };

    fetchGoldPrice();

    const intervalId = setInterval(fetchGoldPrice, 60000);
    return () => clearInterval(intervalId);
  }, []);

  return <>{goldPrice?.totalAmount ? currenyFormat(goldPrice?.totalAmount) : "NA"}</>;
};

export default Amount;
